module.exports = __webpack_public_path__ + "static/media/game(17).d5cee034.PNG";